export default {
  'movementDirectSaleXFinancial.form.reportType': 'Tipo de relatório',
  'movementDirectSaleXFinancial.form.reportType.noFinancialAndDifferentValue':
    'Sem financeiro/Valor Divergente',
  'movementDirectSaleXFinancial.form.reportType.overview': 'Visão Geral',

  'movementDirectSaleXFinancial.form.orderOfReport': 'Ordem do Relatório',
  'movementDirectSaleXFinancial.form.orderOfReport.numberDirectSale': 'Nº VD',
  'movementDirectSaleXFinancial.form.orderOfReport.employee': 'Funcionário',
  'movementDirectSaleXFinancial.form.onlyDirectSaleWithoutFinancialRegistration':
    'Somente VD sem registro no financeiro',

  'movementDirectSaleXFinancial.form.filterByDate': 'Filtrar por data de',
  'movementDirectSaleXFinancial.form.filterByDate.directSale': 'Venda Direta',
  'movementDirectSaleXFinancial.form.filterByDate.financial': 'Financeiro',

  'movementDirectSaleXFinancial.form.filterDirectSalesBy':
    'Filtrar Venda Direta por',
  'movementDirectSaleXFinancial.form.filterDirectSalesBy.sale': 'Venda',
  'movementDirectSaleXFinancial.form.filterDirectSalesBy.authorization':
    'Autorização',

  'movementDirectSaleXFinancial.form.filterFinancialBy':
    'Filtrar Financeiro por',
  'movementDirectSaleXFinancial.form.filterFinancialBy.emission': 'Emissão',
  'movementDirectSaleXFinancial.form.filterFinancialBy.dueDate': 'Vencimento',
  'movementDirectSaleXFinancial.form.filterFinancialBy.receipt': 'Recebimento',

  'movementDirectSaleXFinancial.form.moreOptions': 'Mais opções',
  'movementDirectSaleXFinancial.form.moreOptions.employee': 'Funcionário',
  'movementDirectSaleXFinancial.form.moreOptions.documentTypes':
    'Tipos de Documento',
};
